"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _react = _interopRequireDefault(require("react"));
var _token = require("@jarvis/token");
var S = _interopRequireWildcard(require("./Option.styles"));
var _typography = _interopRequireDefault(require("../../Typography"));
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Option = /*#__PURE__*/ _react.default.forwardRef(function(_param, ref) {
    var label = _param.label, value = _param.value, name = _param.name, _isSelected = _param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, _colorVariant = _param.colorVariant, colorVariant = _colorVariant === void 0 ? "white" : _colorVariant, onChange = _param.onChange, props = _objectWithoutProperties(_param, [
        "label",
        "value",
        "name",
        "isSelected",
        "colorVariant",
        "onChange"
    ]);
    var inputId = "select-option-".concat(value);
    var handleChange = function() {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime).jsxs(S.Wrapper, _objectSpread({
        role: "option"
    }, isSelected && {
        "aria-selected": "true"
    }, {
        ref: ref
    }, props, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime).jsx(S.Input, {
                id: inputId,
                name: name,
                type: "radio",
                value: value,
                onChange: handleChange,
                checked: isSelected
            }),
            /*#__PURE__*/ (0, _jsxRuntime).jsx(S.Label, {
                htmlFor: inputId,
                isSelected: isSelected,
                colorVariant: colorVariant,
                children: /*#__PURE__*/ (0, _jsxRuntime).jsx(_typography.default, {
                    variant: "body2",
                    fontWeight: "regular",
                    colorVariant: _token.COLOR_TEXT_3,
                    children: label
                })
            })
        ]
    }));
});
var _default = /*#__PURE__*/ _react.default.memo(Option);
exports.default = _default;
